import { ArrowRightIcon } from 'lucide-react';

import React from 'react';

import { useNamespace, useTranslation } from '@splitfiesta/i18n';
import { Alert, Button, Card } from '@splitfiesta/ui';

import { RouteChangeLink } from '@/components/common/RouteChangeLink';

interface GroupMemberSelectionProps {
  mode?: 'create' | 'edit';
  groupId?: string;
}

export function GroupMemberSelection({
  mode = 'create',
  groupId,
}: GroupMemberSelectionProps) {
  const { t } = useTranslation();

  // Load required namespaces
  useNamespace('groups');

  return (
    <Card>
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          {t('groups:memberSelection.title')}
        </h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          {mode === 'create'
            ? t('groups:memberSelection.createDescription')
            : t('groups:memberSelection.editDescription')}
        </p>
      </div>

      <Alert
        type="info"
        message={
          mode === 'create'
            ? t('groups:memberSelection.inviteAfterCreation')
            : t('groups:memberSelection.manageFromGroupPage')
        }
        className="mt-4"
      />

      {mode === 'edit' && (
        <RouteChangeLink href={`/groups/${groupId}/members`}>
          <Button
            variant="outline"
            className="w-full mt-4"
            rightIcon={<ArrowRightIcon className="w-4 h-4" />}
          >
            {t('groups:memberSelection.goToMembers')}
          </Button>
        </RouteChangeLink>
      )}
    </Card>
  );
}

export default GroupMemberSelection;
